import { render, staticRenderFns } from "./com-result.vue?vue&type=template&id=28c8726f&scoped=true"
import script from "./com-result.vue?vue&type=script&lang=js"
export * from "./com-result.vue?vue&type=script&lang=js"
import style0 from "./com-result.vue?vue&type=style&index=0&id=28c8726f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8726f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c8726f')) {
      api.createRecord('28c8726f', component.options)
    } else {
      api.reload('28c8726f', component.options)
    }
    module.hot.accept("./com-result.vue?vue&type=template&id=28c8726f&scoped=true", function () {
      api.rerender('28c8726f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-result/com-result.vue"
export default component.exports